
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media",
      function () {
        return require("private-next-pages/media.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media"])
      });
    }
  